var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMipIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_635_85974)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3169 5.78125H21.829C19.9875 5.78125 18.3383 6.60437 17.2302 7.90311C17.5159 8.23854 17.7662 8.60411 17.9742 8.99607C18.9895 7.08376 21.0013 5.78125 23.3169 5.78125Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2256 29.0156C43.0828 30.2659 42.0242 31.2088 40.7662 31.2088C39.521 31.2088 38.4688 30.2839 38.3106 29.049L37.715 24.4092C37.6545 23.941 37.6905 23.4844 37.8063 23.0586",
    stroke: "currentColor",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6492 31.2422V33.2604",
    stroke: "currentColor",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8656 24.6077C44.8656 24.6077 35.2426 22.0595 34.8773 22.9509C34.5802 23.6777 37.7136 24.4096 37.7136 24.4096",
    stroke: "currentColor",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5738 33.2806L44.377 29.3444C44.3654 28.9585 44.3808 28.5713 44.422 28.1867L44.8182 24.6082C44.8722 24.0769 46.3271 23.0594 44.9558 21.9635C43.1948 20.5549 35.3856 18.7618 37.0964 22.9012",
    stroke: "currentColor",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0928 23.6836C41.0928 23.6836 41.1224 24.6496 41.6639 25.4986C42.8435 23.8418 44.7228 25.8922 43.1612 27.1438C43.1612 27.1438 43.7027 27.7175 44.4565 27.8667",
    stroke: "currentColor",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.992 33.2617H38.0019C36.2654 33.2617 34.8568 34.6702 34.8568 36.4068V38.2925C34.8568 40.5822 30.6441 42.549 30.4177 51.6845",
    stroke: "currentColor",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6031 57.4059C32.0757 56.9454 32.0037 56.1518 32.4398 55.6038L34.5674 52.7237C35.0845 52.0728 35.8074 51.6175 36.6165 51.4297L50.2142 48.2794C51.8016 47.9115 53.3825 48.9097 53.7349 50.4996C54.117 52.2259 52.8937 53.8943 51.1314 54.0499L37.0371 55.2873L34.3037 57.4252C33.8084 57.8368 33.0881 57.8278 32.6031 57.4046V57.4059Z",
    stroke: "currentColor",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6435 50.1777L49.8553 35.3065C49.508 33.9507 48.1934 33.076 46.8093 33.2793C45.2142 33.5134 44.1659 35.0685 44.5492 36.6353L47.5283 48.9017",
    stroke: "currentColor",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1533 43.242L51.5212 41.8477",
    stroke: "currentColor",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1301 40.5156L32.967 42.0004",
    stroke: "currentColor",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5081 33.2822L40.0393 35.294L43.5227 33.2539",
    stroke: "currentColor",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.55 54.7891L9.80044 59.4649C7.82978 60.135 6.50358 61.9861 6.50358 64.0673V81.9408C6.50358 85.1695 5.65332 86.5292 5.65332 86.5292L14.255 87.7576",
    stroke: "currentColor",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5701 52.7422L24.6216 54.4247",
    stroke: "currentColor",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.55 57.0938L16.5768 59.4644C14.6062 60.1346 13.2799 61.9856 13.2799 64.0669V81.9404C13.2799 85.1691 12.4297 86.5288 12.4297 86.5288L21.4082 87.8112",
    stroke: "currentColor",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9538 53.5547L24.5791 56.7422",
    stroke: "currentColor",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3905 97.1921C56.3544 97.1921 65.2423 88.3041 65.2423 77.3402C65.2423 66.3763 56.3544 57.4883 45.3905 57.4883C34.4266 57.4883 25.5386 66.3763 25.5386 77.3402C25.5386 88.3041 34.4266 97.1921 45.3905 97.1921Z",
    stroke: "currentColor",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3905 95.2869C55.3009 95.2869 63.3348 87.253 63.3348 77.3427C63.3348 67.4324 55.3009 59.3984 45.3905 59.3984C35.4802 59.3984 27.4463 67.4324 27.4463 77.3427C27.4463 87.253 35.4802 95.2869 45.3905 95.2869Z",
    stroke: "currentColor",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4172 57.7287V54.2891",
    stroke: "currentColor",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5222 52.7439H25.9592C25.1976 52.7439 24.5789 53.3626 24.5789 54.1241V91.16C24.5789 92.5133 23.4778 93.6144 22.1246 93.6144H1.63343C1.34915 93.6144 1.1189 93.3841 1.1189 93.0998C1.1189 92.8156 1.34915 92.5853 1.63343 92.5853H22.1246C22.9106 92.5853 23.5499 91.946 23.5499 91.16V54.1241C23.5499 52.7954 24.6304 51.7148 25.9592 51.7148H35.824",
    stroke: "currentColor",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7707 51.7148H55.4751C55.7594 51.7148 55.9896 51.9451 55.9896 52.2294C55.9896 52.5137 55.7594 52.7439 55.4751 52.7439H53.3501",
    stroke: "currentColor",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5596 56.828V54.1241C17.5596 52.7954 18.6401 51.7148 19.9689 51.7148H25.5052",
    stroke: "currentColor",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9861 52.7422H19.9676C19.2061 52.7422 18.5874 53.3609 18.5874 54.1224V56.4764",
    stroke: "currentColor",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.657 46.307V44.6977M50.0239 35.9727H52.657V35.9727C52.657 37.6692 54.0323 39.0445 55.7288 39.0445H66.7081",
    stroke: "currentColor",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.657 58.8622V53.4609",
    stroke: "currentColor",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6571 35.9746V34.5519L55.595 31.8468C55.8047 31.6551 55.8189 31.3297 55.6259 31.12C55.4342 30.9103 55.1088 30.8962 54.8991 31.0891L52.0126 33.811C51.6988 34.1069 51.5212 34.5198 51.5212 34.9507V35.9746",
    stroke: "currentColor",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6025 49.1853C30.246 49.4846 29.747 49.777 29.3114 49.8825C27.5943 50.2964 25.9043 49.1062 25.7166 47.3499L24.3018 34.1227L21.4744 32.4464C21.099 32.224 20.888 31.8041 20.9317 31.37C21.0339 30.3549 21.8745 30.3144 23.2026 30.4706",
    stroke: "currentColor",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2305 7.90311C18.3393 6.60437 19.9885 5.78125 21.8292 5.78125H23.3172",
    stroke: "currentColor",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.35181 14.5781C7.03196 22.2869 16.4865 26.8299 16.4865 26.8299H17.9744",
    stroke: "currentColor",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6113 5.78125H11.1437C9.21859 5.78125 7.50452 6.81467 6.39724 8.32974C6.17714 8.63125 5.82437 8.80839 5.45126 8.80839H0",
    stroke: "currentColor",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8759 17.5551C28.7796 15.9247 29.3638 14.1345 29.3638 12.2305C29.3638 8.8913 26.657 5.78125 23.3178 5.78125C21.0023 5.78125 18.9904 7.08376 17.9751 8.99607C16.9598 7.08376 14.9487 5.78125 12.6324 5.78125C9.29321 5.78125 6.58643 8.8913 6.58643 12.2305C6.58643 21.3556 17.9751 26.8272 17.9751 26.8272C17.9751 26.8272 20.2213 25.6061 22.7186 23.5122C22.9296 23.335 23.1972 23.237 23.4739 23.237H25.8588C26.5078 23.237 27.0347 23.7632 27.0347 24.4129V30.7589C27.0347 31.0446 27.1342 31.3242 27.3271 31.5345C27.5442 31.7727 27.7078 32.0622 27.796 32.3863L30.3016 41.6463L35.5026 34.5232",
    stroke: "currentColor",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_635_85974"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMipIcon);
export default __webpack_public_path__ + "static/media/mip-icon.f8fc42b6.svg";
export { ForwardRef as ReactComponent };